<template>
<a href="###" :class="current" :data-scp="scp" @click.prevent="shareControl" v-if="show">
	<i class="icon icon-share"></i><span>分享</span>
</a>
</template>
<script>
export default {
	props: ['current', 'scp']
	, methods: {
		shareControl: function(){
			this.$dispatch('shareControl');
		}
	},
	data:function(){
		return {
			show:!!maple.cookie('hybrid')
		}
	}
};
</script>